// Auto-detect Rechtsform from a Firmenname string.
// Returns one of the canonical Rechtsformen, or "Einzelunternehmen" as fallback.

const RULES = [
  // Most specific first
  { rf: "GmbH & Co. KG", re: /\bgmbh\s*&?\s*co\.?\s*kg\b|\bgesellschaft\s+mit\s+beschränkter\s+haftung\s*(&|und)\s*co\.?\s*kg\b/i },
  { rf: "GmbH & Co. KGaA", re: /\bgmbh\s*&?\s*co\.?\s*kgaa\b/i },
  { rf: "UG (haftungsbeschränkt)", re: /\bug\s*\(?\s*haftungsbeschr(ä|ae)nkt\s*\)?/i },
  { rf: "UG (haftungsbeschränkt)", re: /\bunternehmergesellschaft\b/i },
  { rf: "PartG mbB", re: /\bpartg\s*mbb\b|\bpartnerschaft.*mit\s+beschr(ä|ae)nkter\s+berufshaftung\b/i },
  { rf: "Partnerschaftsgesellschaft (PartG)", re: /\bpartg\b|\bpartnerschaftsgesellschaft\b/i },
  { rf: "Genossenschaft (eG)", re: /\beg\b|\bgenossenschaft\b/i },
  { rf: "Stiftung", re: /\bstiftung\b/i },
  { rf: "AG", re: /\bag\b|\baktiengesellschaft\b/i },
  { rf: "KGaA", re: /\bkgaa\b|\bkommanditgesellschaft\s+auf\s+aktien\b/i },
  { rf: "GmbH", re: /\bgmbh\b|\bgesellschaft\s+mit\s+beschr(ä|ae)nkter\s+haftung\b/i },
  { rf: "OHG", re: /\bohg\b|\boffene\s+handelsgesellschaft\b/i },
  { rf: "KG", re: /\bkg\b|\bkommanditgesellschaft\b/i },
  { rf: "GbR", re: /\bgbr\b|\bgesellschaft\s+b(ü|ue)rgerlichen\s+rechts\b/i },
  { rf: "e.K.", re: /\be\.?\s*k\.?\b|\beingetragener?\s+kaufmann\b|\beingetragene\s+kauffrau\b/i },
  { rf: "e.V.", re: /\be\.?\s*v\.?\b|\beingetragener?\s+verein\b/i },
  { rf: "SE", re: /\bse\b|\bsocietas\s+europaea\b/i },
];

export const detectRechtsform = (firmenname) => {
  if (!firmenname || typeof firmenname !== "string") return "";
  // Pad with spaces so word boundaries work on edges
  const s = ` ${firmenname.trim()} `;
  for (const { rf, re } of RULES) {
    if (re.test(s)) return rf;
  }
  return "Einzelunternehmen";
};
